module.exports = __webpack_public_path__ + "img/brandstory_logo2.b0f455c0.png";